class heroVideoDesktop extends HTMLElement {
  constructor() {
    super();
    this.videos = this.querySelector('.video-frame-desktop');
    this.videoloop = this.videos.querySelector("#loopVideo");
    this.videobanner = this.videos.querySelector('#heroBannerVideo');
    this.speed = parseInt(this.videoloop.innerHTML);
    this.__setupEventListener();
  }
  __setupEventListener(){
      this.videobanner.addEventListener('ended',this.myHandler.bind(this),false);
  }
  myHandler() {
    const _this = this;
    setTimeout(function(){
      _this.videobanner.play();
    }, _this.speed*1000);
  };
}
customElements.define("video-loop", heroVideoDesktop);

class heroVideoMobile extends HTMLElement {
  constructor() {
    super();
    this.videos = this.querySelector('.video-frame-mobile');
    this.videoloop = this.videos.querySelector("#loopVideoMobile");
    this.videobanner = this.videos.querySelector('#heroBannerVideoMobile');
    this.speed = parseInt(this.videoloop.innerHTML);
    this.__setupEventListener();
  }
  __setupEventListener(){
      this.videobanner.addEventListener('ended',this.myHandler.bind(this),false);
  }
  myHandler() {
    const _this = this;
    setTimeout(function(){
      _this.videobanner.play();
    }, _this.speed*1000);
  };
}
customElements.define("video-loop-mobile", heroVideoMobile);